module.exports = __webpack_public_path__ + "static/media/mobile-image-background-checker-pattern-2.fee96884.svg";